import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class List extends React.Component {

	@observable records = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.records = await store.model.BaseLaw.find({ order: 'id desc' });
	};
	
	create = () => this.props.history.push('/admin/baselaws/create');
	
	render() {
		if (!this.records) return '...';
		
		return <>
			<p>Базовые законы</p>
			<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
			<Table records={this.records} rootPath="/admin">
				<Column property="name" label="Наименование" />
				<Column property="number" label="Номер" />
				<Column property="date" label="Дата" />
				<Column property="author" label="Инициатор" />
			</Table>
		</>;
	}
	
}
